import { Color, StressValue } from 'root-constants'

export const ENERGY_LEVEL_TEXT_MAP = {
  [StressValue.LOW]: {
    textKey: 'result.energyLevel.full',
    textColor: '#17ccff',
  },
  [StressValue.MODERATE]: {
    textKey: 'result.energyLevel.tired',
    textColor: Color.ORANGE,
  },
  [StressValue.SEVERE]: {
    textKey: 'result.energyLevel.dragging',
    textColor: '#e22a61',
  },
}

export const INDICATOR_VALUES_MAP = {
  [StressValue.LOW]: [
    { id: '1', opacity: 1 },
    { id: '2', opacity: 1 },
    { id: '3', opacity: 1 },
    { id: '4', opacity: 1 },
    { id: '5', opacity: 0.1 },
  ],
  [StressValue.MODERATE]: [
    { id: '1', opacity: 1 },
    { id: '2', opacity: 1 },
    { id: '3', opacity: 0.6 },
    { id: '4', opacity: 0.1 },
    { id: '5', opacity: 0.1 },
  ],
  [StressValue.SEVERE]: [
    { id: '1', opacity: 1 },
    { id: '2', opacity: 0.6 },
    { id: '3', opacity: 0.1 },
    { id: '4', opacity: 0.1 },
    { id: '5', opacity: 0.1 },
  ],
}
